import { AudioEngine } from '../audio/engine';
import { GAME_CONFIG } from '../config/gameConfig';
import type { GameState } from '../state/types';
import { showEndScreen } from '../ui/endScreen';

/** Apply win/lose if conditions are met. No-op while already ended. */
export function evaluateOutcome(state: GameState): void {
  if (state.phase !== 'playing') return;

  if (state.cash >= GAME_CONFIG.economy.winCash) {
    state.phase = 'won';
    showEndScreen('won');
    AudioEngine.playBeep(523, 'sine', 0.2);
    setTimeout(() => AudioEngine.playBeep(659, 'sine', 0.2), 120);
    setTimeout(() => AudioEngine.playBeep(784, 'sine', 0.35), 240);
    return;
  }

  if (state.fields.length > 0 && state.fields.every((f) => f.dead)) {
    state.phase = 'lost';
    showEndScreen('lost');
    AudioEngine.playBeep(165, 'sawtooth', 0.45);
    setTimeout(() => AudioEngine.playBeep(110, 'sawtooth', 0.55), 180);
  }
}
